
export default class EntityProvider {

    constructor({ userGroups, timeZoneGroups, leaveTypes }) {
        this.userGroups = userGroups
        this.timeZoneGroups = timeZoneGroups
        this.leaveTypes = leaveTypes
    }

    getUserGroup(id) {
        return entityOrError("user group", this.userGroups, id)
    }

    getTimeZoneGroup(id) {
        return entityOrError("tz group", this.timeZoneGroups, id)
    }

    getLeaveType(id) {
        return entityOrError("leave type", this.leaveTypes, id)
    }

}

function entityOrError(entityName, mapping ,id) {
    if (mapping === null || mapping === undefined) {
        throw new MappingNotFound(`Mapping for '${entityName}' not defined`)
    }

    let ent = mapping[id]
    if (ent === null || ent === undefined) {
        throw new EntityNotFound(`Not found '${entityName}' with id=${id}.\n\n Only found:\n ${JSON.stringify(mapping, null, 4)} `)
    }
    return ent
}

export class EntityNotFound extends Error {
    isInstanceOfEntityNotFound = true
}
export class MappingNotFound extends Error {
}


// WEBPACK FOOTER //
// ./web/actiplans/js/administration/corporateRequests/exportToCsv/EntityProvider.js